// extracted by mini-css-extract-plugin
export var attachmentContainer = "_k5-0";
export var fileList = "_k5-2";
export var removeFileButton = "_k5-1";